import React from 'react';
import MediaQuery from 'react-responsive';
import OurDifferenceLanding from 'components/organisms/ourDifferenceLandingScreen';
import CultureLeadershipMobileView from 'components/organisms/cultureLeadershipMobile';

// TODO: Define props

const CultureLeadershipSection = props => {
  const { ourDifferenceData, cmsDetailsData } = props.data;

  const { breadcrumbList, sectionId } = props;

  const infoLinks = [];
  let our_difference_heading = ' ',
    our_difference_description = ' ',
    mobile_description = '';

  for (let i = 0; i < ourDifferenceData.length; i++) {
    let info = {};
    if (
      ourDifferenceData[i].parent_page_title === '' ||
      ourDifferenceData[i].parent_page_title === null
    ) {
      our_difference_heading = ourDifferenceData[i].page_title;
      our_difference_description = ourDifferenceData[i].short_content;
      mobile_description = ourDifferenceData[i].short_mobile_content;
    } else {
      info.data = ourDifferenceData[i];
      info.title = ourDifferenceData[i].page_title;
      info.link = '#';
      info.cms_page_id = ourDifferenceData[i].cms_page_id
        ? ourDifferenceData[i].cms_page_id
        : '';
      info.id = infoLinks.length;
      infoLinks.push(info);
    }
  }
  return (
    <div id={sectionId}>
      <MediaQuery maxDeviceWidth={575.6}>
        <CultureLeadershipMobileView
          our_difference_heading={our_difference_heading}
          our_difference_description={mobile_description}
          infoLinks={infoLinks}
          cmsDetailsData={cmsDetailsData}
          breadcrumbList={breadcrumbList}
        />
      </MediaQuery>
      <MediaQuery minDeviceWidth={576}>
        <OurDifferenceLanding
          our_difference_heading={our_difference_heading}
          our_difference_description={our_difference_description}
          infoLinks={infoLinks}
          heading_classname={'culture-leadership-heading'}
          cmsDetailsData={cmsDetailsData}
          breadcrumbList={breadcrumbList}
        />
      </MediaQuery>
    </div>
  );
};

export default CultureLeadershipSection;
